import { useTranslation } from "@/hooks/useTranslation";
import { cn } from "@/lib/utils";

type ShowMoreButtonProps = {
  isExpanded: boolean;
  hiddenCount?: number;
  onToggle: () => void;
  className?: string;
};

/**
 * Consistent "Show more (+N)" / "Show less" toggle button used across
 * company cards (technologies, market categories, corporate object,
 * affiliated entities, etc.).
 */
export default function ShowMoreButton({
  isExpanded,
  hiddenCount,
  onToggle,
  className,
}: ShowMoreButtonProps) {
  const { t } = useTranslation();

  const label = isExpanded
    ? t("company.showMoreLess.showLess")
    : hiddenCount != null
      ? t("company.showMoreLess.showMore", { count: hiddenCount })
      : t("company.showMoreLess.showMore");

  return (
    <button
      type="button"
      onClick={onToggle}
      className={cn(
        "self-start text-xs font-medium cursor-pointer text-majorelle hover:underline active:brightness-75 transition",
        className,
      )}
    >
      {label}
    </button>
  );
}
